const defaultState = {
  data: [],
  breadcrumbs: [],
  loading: false,
  error: false,
};

const reportCanvasserEvents = function (state = defaultState, action) {
  let data, target;

  switch (action.type) {
    case "SET_REPORT_CANVASSER_EVENTS_LOADING":
      return { ...state, loading: action.data };

    case "SET_REPORT_CANVASSER_EVENTS_ERROR":
      return { ...state, error: action.data };

    case "SET_REPORT_CANVASSER_BREADCRUMBS":
      return { ...state, breadcrumbs: action.data };

    case "SET_REPORT_CANVASSER_EVENTS":
      return { ...state, data: action.data };

    case "CLEAR_REPORT_CANVASSER_EVENTS":
      return { ...state, data: action.data };

    default:
      return state;
  }
};

export default reportCanvasserEvents;
